import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import EditActiveProtocolPage from './EditActiveProtocolPage.js';

export default WithGASetup(EditActiveProtocolPage, AuthContext);
